import { FC } from 'react';
import { faReceipt } from '~/assets';
import { If } from '~/components';
import { currencyParser } from '~/modules';
import { TransactionType, formatTimestampToDate } from '~/utils';
import TransactionTypeIndicator from '../TransactionTypeIndicator';
import { ButtonReceipt, Card, Description, IconReceipt, Row } from './styles';

type Props = {
  transactionType?: TransactionType;
  value?: number;
  date?: number;
  installments?: {
    totalInstallments: string;
    installmentNumber: string;
    transactionDate: string;
  };
  onPress(): void;
};

const AccountTransactionRow: FC<Props> = ({
  date,
  transactionType,
  value,
  installments,
  onPress,
}) => {
  return (
    <Card>
      <Row>
        <TransactionTypeIndicator type={transactionType} />
      </Row>
      <Row>
        <If condition={!!installments}>
          Parcela {installments?.installmentNumber} de{' '}
          {installments?.totalInstallments}
        </If>
      </Row>
      <Row>
        <Description>{currencyParser(value || '')}</Description>
      </Row>
      <Row>
        <Description>{formatTimestampToDate(date)}</Description>
      </Row>
      <Row>
        <ButtonReceipt id="btn_receipt" onPress={onPress}>
          <IconReceipt icon={faReceipt} />
        </ButtonReceipt>
      </Row>
    </Card>
  );
};

export default AccountTransactionRow;
